import { ENTRY_TYPES, VALIDATION_RULES } from '../../../../../../../../constants';
import Reports from '../../../../../services/api/reports';

const reports = new Reports();

export const mapMilestonePayload = (params, includeInfo = true, includeFields = true) => {
  const payload = new FormData();

  if (includeInfo) {
    payload.append('project', params.project);
    payload.append('templateId', params.templateId);
    payload.append('name', params.name);
    payload.append('customers', params.customers);
    payload.append('machines', params.machines);
    payload.append('contacts', params.contacts);
    payload.append('number', params.number);
    payload.append('description', params.description);
    payload.append('leader', params.leader);
    payload.append('email', params.email);
    payload.append('emailCC', params.emailCC);
    payload.append('checklistNo', params.checklistNo);
    payload.append('startDate', params.startDate);
    payload.append('endDate', params.endDate);
    payload.append('status', params.status);
    payload.append('remoteSupport', params.remoteSupport);
    payload.append('onSiteSupport', params.onSiteSupport);
    payload.append('isOnSiteSupportOnly', params.isOnSiteSupportOnly);
  }

  if (includeFields) {
    params.fields.forEach((field) => {
      if (field.entryType === ENTRY_TYPES.MULTIPLE_CHECKBOXES && field.value && Object.keys(field.value).length === 0) {
        field.value = null;
      }

      const isAttachFileToEmailRule = field.rules && field.rules.find((r) => r.name === VALIDATION_RULES.IS_ATTACH_FILE_TO_EMAIL);
      if (isAttachFileToEmailRule) {
        payload.append(`${field.key}_attachToEmail`, field.isAttachFileToEmail);
      }

      payload.append(`field_${field.key}`, reports.mapFieldValue(field));
      if (field.showTextInput) {
        payload.append(`field_${field.key}_textInputValue`, typeof field.textInputValue !== 'undefined' ? field.textInputValue : null);
      }
    });
  }
  return payload;
};

export const isSignatureDisableFunction = ({ selectedTemplate, confirmationValues, fieldsValue }) => {
  let result = false;
  if (selectedTemplate && selectedTemplate.groups && confirmationValues) {
    selectedTemplate.groups.forEach(({ id, isConfirmation, fields }) => {
      if (isConfirmation && confirmationValues[id] && (!confirmationValues[id].onSiteSupport || !confirmationValues[id].remoteSupport)) {
        result = true;
      }
      if (isConfirmation) {
        fields.forEach(({ required, entryType, id, key }) => {
          if (required && entryType !== ENTRY_TYPES.SIGNATURE) {
            const currentValue = fieldsValue[id] || fieldsValue[key];
            let inputValue;
            try {
              inputValue = JSON.parse(currentValue);
            } catch (e) {
              inputValue = currentValue;
            }

            if (entryType === ENTRY_TYPES.CHECKBOX && !inputValue) {
              inputValue = null;
            }

            const isMultipleCheckboxType = entryType === ENTRY_TYPES.MULTIPLE_CHECKBOXES;
            if (isMultipleCheckboxType && inputValue) {
              const isEveryValueFalse = !Object.values(inputValue).some((value) => !!value);
              if (isEveryValueFalse) inputValue = null;
            }

            const isLocationType = entryType === ENTRY_TYPES.LOCATION;
            const isTimeType = entryType === ENTRY_TYPES.TIME;
            if ((isLocationType || isTimeType) && inputValue) {
              const isEmptyObj = Object.values(inputValue).some((value) => !value);
              if (isEmptyObj) inputValue = null;
            }

            if (typeof inputValue === 'undefined' || inputValue === null || inputValue === '') {
              result = true;
            }
          }
        });
      }
    });
  }
  return result;
};
